__turbopack_context__.v({
  "card": "Card-module__e54Bea__card",
  "content": "Card-module__e54Bea__content",
  "default": "Card-module__e54Bea__default",
  "description": "Card-module__e54Bea__description",
  "elevated": "Card-module__e54Bea__elevated",
  "flat": "Card-module__e54Bea__flat",
  "footer": "Card-module__e54Bea__footer",
  "header": "Card-module__e54Bea__header",
  "interactive": "Card-module__e54Bea__interactive",
  "outlined": "Card-module__e54Bea__outlined",
  "padding-lg": "Card-module__e54Bea__padding-lg",
  "padding-md": "Card-module__e54Bea__padding-md",
  "padding-none": "Card-module__e54Bea__padding-none",
  "padding-sm": "Card-module__e54Bea__padding-sm",
  "title": "Card-module__e54Bea__title",
});
